import React from 'react';
import './styles.css';

const Popup = ({ 
  isOpen, 
  title, 
  message, 
  type = 'info', // info, success, warning, error
  onConfirm,
  onCancel,
  confirmText = 'Đồng ý',
  cancelText = 'Hủy',
  showCancelButton = true
}) => {
  if (!isOpen) return null;

  const handleConfirm = (e) => {
    e.preventDefault(); // Ngăn chặn hành vi mặc định
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancel = (e) => {
    e.preventDefault(); // Ngăn chặn hành vi mặc định
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${type}`}>
        <div className="popup-icon">
          {type === 'info' && <i className="fas fa-info-circle"></i>}
          {type === 'success' && <i className="fas fa-check-circle"></i>}
          {type === 'warning' && <i className="fas fa-exclamation-triangle"></i>}
          {type === 'error' && <i className="fas fa-times-circle"></i>}
        </div>
        
        <h3 className="popup-title">{title}</h3>
        <p className="popup-message">{message}</p>
        
        <div className="popup-actions">
          <button 
            className={`btn btn-${type}`}
            onClick={handleConfirm}
            type="button" // Thêm type button
          >
            {confirmText}
          </button>
          
          {showCancelButton && (
            <button 
              className="btn btn-outline-secondary"
              onClick={handleCancel}
              type="button" // Thêm type button
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup; 